import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import 'react-dropdown-tree-select/dist/styles.css';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import { CircularProgress, Backdrop } from "@mui/material";
import { handleErrors, checkPrivilege } from "common.js";
import { PRIVILEGE, CATEGORY } from "constants.js";
import MDTypography from "components/MDTypography/index.js";

function EditCategory(props) {
  const navigate = useNavigate();
  const params = useParams();
  const id = params.id;
  const type = params.type;
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [categoryData, setCategoryData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const adminType = localStorage.getItem("type");

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const data = (id) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/category/view/" + id + '/' + type,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false)
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          setCategoryData(response.data)
          setValueFn(response.data.data)
        }
        else {
          if (message != '')
            toast.error(t(message))
              (function () {
                const redirectTimeout = setTimeout(() => {
                  clearTimeout(redirectTimeout);
                  navigate((type == CATEGORY.PRODUCT) ? '/productCategory/list/' : (type == CATEGORY.SERVICE) ? '/serviceCategory/list/' : '/productCategory/list/');
                }, 3000);
              })()
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    })
      .catch(function (error) {
        setIsLoading(false);
        handleErrors(error, t, navigate);
      });
  }

  useEffect(() => {
    data(id);
  }, []);

  const setValueFn = (setValueData) => {
    setValue('id', id);
    setValue('name', setValueData.name);
    setValue('handle', setValueData.handle);
    setValue('collectionId', setValueData.collectionId);
    setValue('tagName', setValueData.tagName);
  }

  const onSubmit = async (data) => {
    data.type = type;
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/category/edit",
      method: "POST",
      data: data,
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate((type == CATEGORY.PRODUCT) ? '/productcategory/list' : (type == CATEGORY.SERVICE) ? '/servicecategory/list' : null);
          }, 3000);
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == CATEGORY.PRODUCT) ? t('edit product category') : (type == CATEGORY.SERVICE) ? t('edit service category') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={2} pb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card>
              {(categoryData) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={5}>
                      <Grid item xs={12} sm={4} md={4}>
                        <label className="labelCls">{t('categoryName')}  <i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="name" label="" {...register("name", { required: true })} fullWidth />
                        {errors.name && errors.name.type === "required" && (
                          <p className="errorMsg">{t('Name is mandatory')}</p>
                        )}
                        {errors.name && (
                          <p className="errorMsg">{errors.name.message}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography component="span" className="categoryNoteIcon"># </MDTypography>
                        <label className="labelCls">{t('handle')}  <i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="handle" label="" {...register("handle", { required: true })} fullWidth />
                        {errors.handle && errors.handle.type === "required" && (
                          <p className="errorMsg">{t('handleRequired')}</p>
                        )}
                        {errors.handle && (
                          <p className="errorMsg">{errors.handle.message}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                        <MDTypography component="span" className="categoryNoteIcon">## </MDTypography>
                        <label className="labelCls">{t('tag name')}</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="tagName" label="" {...register("tagName")} fullWidth />
                      </Grid>
                      <Grid item xs={12} sm={4} md={4}>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        {(adminType == PRIVILEGE.ADMIN || (adminType == PRIVILEGE.SUBADMIN && checkPrivilege("category", "write"))) ?
                          <MDButton type="submit" variant="gradient" color="info" className="edit-button-mb" disableRipple>{t('Update')}</MDButton>
                          : null
                        }
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} className="categoryNote">
                        <MDTypography component="span" className="categoryNoteIcon"># </MDTypography>
                        <MDTypography component="span" variant="caption" className="shopifyHandleNote">{t('shopifyHandleNote')}</MDTypography>
                      </Grid>
                      <Grid item xs={12} sm={12} md={12} className="categoryNote">
                        <MDTypography component="span" className="categoryNoteIcon">## </MDTypography>
                        <MDTypography component="span" variant="caption" className="shopifyHandleNote"> {t('tagNameNote')}</MDTypography>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
                : null}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default EditCategory;
